import React from 'react';

import PropTypes from 'prop-types';

import global from '@src/css/global.scss';

export const Agent360Keyword = (props) => {
    const { children } = props;

    if (children) {
        return <span>{children}<span className={global.lighter}> | </span>Agent360</span>;
    }

    return (
        <span><span className={global.lighter}> | </span>Agent360</span>
    );
};

Agent360Keyword.propTypes = {
    children: PropTypes.node,
};
